import { render } from "./App.vue?vue&type=template&id=f6d87730"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f6d87730&lang=css"

import exportComponent from "/home/builder/shared-storage/.project-directory/login-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__